import * as React from 'react';

import DrawerList from './Drawer/DrawerList';

import { Box, AppBar, Drawer, IconButton, Toolbar, Button, Menu, Avatar, Typography, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Settings from '@mui/icons-material/Settings';

//Router-dom
import { Link } from 'react-router-dom';

//IMG
import logo from '../../assets/images/Logo_Nefropolis.png';

//redux
import { useSelector } from 'react-redux';

//actions
import { logout } from '../../actions/user';
import { useDispatch } from 'react-redux';

const ColorButton = styled(Button)(({ theme }) => ({
  color: '#358f69',
  border: '1px solid #358f69',
  paddingLeft: '1.2rem',
  paddingRight: '1.2rem',
  '&:hover': {
    backgroundColor: '#358f69',
    color: '#fff'
  },
}));

const LogOutButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: '#0C75BB',
  borderRadius: '20px',
  height: '45px',
  width: '90%',
  transition: '.3s ease-in-out',
  '&:hover': {
    backgroundColor: '#0C75BB',
    color: '#fff'
  },
}));


function ResponsiveDrawer() {
  const dispatch = useDispatch();
  const { loggedUser: { email, username } } = useSelector(state => state.user);

  const userLogout = () => {
    dispatch(logout());
    window.location.reload();
  };

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', mb: 8 }}>
      <AppBar position="fixed" style={{ background: '#ffff', zIndex: '2' }}>
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, color: 'black' }}>
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }}>
            <Link to="/">
              <img src={logo} width="130" alt="Nefrópolis" />
            </Link>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '12px', alignItems: 'center' }}>
            <Box sx={{ display: { xs: 'none', sm: 'flex', md: 'flex', lg: 'flex', xl: 'flex', xxl: 'flex', xxxl: 'flex' }, gap: '12px' }}>
              <ColorButton sx={{ textTransform: 'none' }} startIcon={<HomeIcon />} component={Link} to='/nefro-admin/'>Panel</ColorButton>
              <Avatar onClick={handleMenuOpen} sx={{ width: '36px', height: '36px', fontSize: '16px', fontWeight: '700', background: '#04A6E1', cursor: 'pointer' }}>
                {username?.charAt(0)}
              </Avatar>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              onClick={handleMenuClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  width: 330,
                  maxWidth: '100%',
                  borderRadius: '6px',
                  mt: 1.5,
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },

              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <Box sx={{ p: 1.5, display: 'flex', justifyContent: 'flex-start', gap: '10px', mb: 2 }}>
                <Avatar sx={{ width: '55px', height: '55px', my: 'auto', backgroundColor: '#04A6E1', fontWeight: '600', fontSize: '24px' }}>{username?.charAt(0)}</Avatar>
                <Box sx={{ my: 'auto' }}>
                  <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                    {username}
                  </Typography>
                  <Typography variant='body2' color='text.secondary' sx={{ wordBreak: 'break-word' }} >
                    {email}
                  </Typography>
                </Box>
              </Box>
              <MenuItem component={Link} to='/mi-cuenta/informacion-y-seguridad'>
                <ListItemIcon>
                  <Settings />
                </ListItemIcon>
                <ListItemText>Configuración de la cuenta</ListItemText>
                <ChevronRightIcon />
              </MenuItem>
              <Divider />
              <Box sx={{ p: 1.5, textAlign: 'center' }}>
                <LogOutButton variant='outlined' onClick={userLogout}>Cerrar sesión</LogOutButton>
              </Box>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav"
        aria-label="mailbox folders">
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          PaperProps={{
            sx: { width: "280px" },
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}>
          {<DrawerList open={() => { setMobileOpen(false) }} />}
        </Drawer>
      </Box>
    </Box>
  );
};

export default ResponsiveDrawer;